module.exports = __webpack_public_path__ + "img/shipo-icon-calendar-black.600e7b54.svg";